import { useCallback, useState } from 'react';

import { useActivityBuilderContext } from 'approot/activity-builder/activity-builder.context';
import { useBatchComponentUpdateContext } from '../shared/batch-component-update.context';
import { FileDropperContextProvider } from 'lib/form/file-dropper/file-dropper.context';
import { useSimpleModalState } from 'approot/shared/modal/modal.hooks';
import { ComponentDimensions } from '../shared/component-height/component-dimensions';
import { EditProps } from './rive.constants';
import RiveEditUpload from './rive-edit-upload';
import RiveModal from './rive-modal';
import RiveView from './rive-view';

const RiveEdit = (props: EditProps) => {
  const { sectionId, id, properties } = props;

  const [newFileProps, setNewFileProps] = useState<{
    key: string;
    fileName: string;
    file: File;
  }>();

  const { isVisible, openModal, closeModal } = useSimpleModalState();
  const { activeComponent } = useActivityBuilderContext();

  const { updateComponentProperties } = useBatchComponentUpdateContext();

  const handleUpdateHeight = useCallback(
    (width: number, height: number) => {
      updateComponentProperties({
        input: {
          sectionId,
          componentId: id,
          componentData: {
            properties: {
              dimensionData: { width, height },
            },
          },
        },
        properties: {
          ...properties,
          dimensionData: {
            ...properties.dimensionData,
            width,
            height,
          },
        },
        typename: 'ActivitiesRiveAnimationComponent',
      });
    },
    [id, sectionId, properties, updateComponentProperties]
  );

  return (
    <ComponentDimensions
      id={id}
      showHandle={activeComponent?.id === id}
      defaultValue={properties.dimensionData}
      onResize={handleUpdateHeight}
    >
      {isVisible && (
        <RiveModal
          {...props}
          fileToUpload={newFileProps}
          onClose={closeModal}
        />
      )}
      {properties.rive?.link ? (
        <RiveView {...props} includeStartOverlay={false} />
      ) : (
        <FileDropperContextProvider>
          <RiveEditUpload
            {...props}
            onShowModal={newFileProps => {
              setNewFileProps(newFileProps);
              openModal();
            }}
          />
        </FileDropperContextProvider>
      )}
    </ComponentDimensions>
  );
};

export default RiveEdit;
